<template>
  <v-row>
    <v-col md="2" sm="6" xs="12">
      <Card
        title="Nové"
        :text="countNewOrders"
        :loading="countNewOrders == null"
        :icon="'mdi-new-box'"
        :iconColor="'primary'"
        @refresh="getCountNewOrders()"
      />
    </v-col>
    <v-col md="2" sm="6" xs="12">
      <Card
        title="Neuhradené"
        :text="unconfirmedOrders"
        :loading="unconfirmedOrders == null"
        :icon="'mdi-exclamation'"
        :iconColor="'error'"
        @refresh="getCountUnconfirmedOrders()"
      />
    </v-col>
    <v-col md="2" sm="6" xs="12">
      <Card
        title="Prebiehajúce"
        :text="countInProgressOrders"
        :loading="countInProgressOrders == null"
        :icon="'mdi-electron-framework'"
        :iconColor="'warning'"
        @refresh="getCountInProgressOrders()"
      />
    </v-col>
    <v-col md="2" sm="6" xs="12">
      <Card
        title="Vyrobené"
        :text="countDoneOrders"
        :loading="countDoneOrders == null"
        :icon="'mdi-package-variant-closed'"
        :iconColor="'#594540'"
        @refresh="getCountFinishedOrders()"
      />
    </v-col>
    <v-col md="2" sm="6" xs="12">
      <Card
        title="Ukončené"
        :text="countCompletedOrders"
        :loading="countCompletedOrders == null"
        :icon="'mdi-check'"
        :iconColor="'success'"
        @refresh="getCountCompletedOrders()"
      />
    </v-col>
    <v-col md="2" sm="6" xs="12">
      <Card
        title="Zrušené"
        :text="countCanceledOrders"
        :loading="countCanceledOrders == null"
        :icon="'mdi-close-circle'"
        :iconColor="'error'"
        @refresh="getCountCanceledOrders()"
      />
    </v-col>
  </v-row>
</template>

<script>
import Card from "@/components/Card";

export default {
  name: "OrderInfoBar",
  components: {
    Card
  },
  data: () => ({
    countNewOrders: null,
    countInProgressOrders: null,
    countDoneOrders: null,
    unconfirmedOrders: null,
    countCompletedOrders: null,
    countCanceledOrders: null
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getCountNewOrders();
      this.getCountInProgressOrders();
      this.getCountFinishedOrders();
      this.getCountCompletedOrders();
      this.getCountUnconfirmedOrders();
      this.getCountCanceledOrders();
    },

    getCountNewOrders() {
      this.countNewOrders = null;
      this.services
        .orderService()
        .getCountOrdersStatus("New")
        .then(response => {
          this.countNewOrders = response.data;
        });
    },
    getCountInProgressOrders() {
      this.countInProgressOrders = null;
      this.services
        .orderService()
        .getCountOrdersStatus("InProgress")
        .then(response => {
          this.countInProgressOrders = response.data;
        });
    },
    getCountFinishedOrders() {
      this.countDoneOrders = null;
      this.services
        .orderService()
        .getCountOrdersStatus("Done")
        .then(response => {
          this.countDoneOrders = response.data;
        });
    },
    getCountCompletedOrders() {
      this.countCompletedOrders = null;
      this.services
        .orderService()
        .getCountOrdersStatus("Completed")
        .then(response => {
          this.countCompletedOrders = response.data;
        });
    },
    getCountCanceledOrders() {
      this.countCanceledOrders = null;
      this.services
        .orderService()
        .getCountOrdersStatus("Canceled")
        .then(response => {
          this.countCanceledOrders = response.data;
        });
    },

    getCountUnconfirmedOrders() {
      this.unconfirmedOrders = null;
      this.services
        .orderService()
        .getCountUnconfirmedOrders()
        .then(response => {
          this.unconfirmedOrders = response.data;
        });
    }
  }
};
</script>
